import axios from "axios";

// check if query params contains apiUrl and set it globally
const queryParams = new URLSearchParams(window.location.search);
if (queryParams.has("apiUrl")) {
  console.log("Setting axios baseURL from query param", queryParams.get("apiUrl"));
  axios.defaults.baseURL = queryParams.get("apiUrl");
}

// check if apiUrl is set in window object
if (window.apiUrl) {
  console.log("Setting axios baseURL from window object to", window.apiUrl);
  axios.defaults.baseURL = window.apiUrl;
}

if (window.CONFIG && window.CONFIG.API_URL) {
  console.log("Setting axios baseURL from window.CONFIG to", window.CONFIG.API_URL);
  axios.defaults.baseURL = window.CONFIG.API_URL;
}

if (!axios.defaults.baseURL) {
  console.log("Setting axios baseURL to origin", window.location.origin);
  axios.defaults.baseURL = window.location.origin;
}
